import { createColumns } from './columnGroupCreator'
import { TableColumn } from './tableTypes'
import { selectColumnId } from './myProductColumnIds'

import { TableDateCell } from '../components/tableCells/TableDateCell'
import { MoySkladIdCell } from '../components/tableCells/MoySkladIdCell'
import { TableSelectCell } from '../components/tableCells/TableSelectCell'
import { OzonOrderSyncLogsCell } from '../components/tableCells/StoreOrderSyncLogsCell'
import { OzonOrderSyncErrorCell } from '../components/tableCells/OzonOrderSyncErrorCell'
import { OzonOrderCommissionsCell } from '../components/tableCells/OrderCommissionsCell'

import { tableCellStyles } from '../hooks/tableStylesHook'

import { formatPrice } from '../common/numberUtils'

import { OzonOrderModel } from '../server/mpsklad_core/Models/Orders/OzonOrderModel'

export type OzonOrderColumnId =
  keyof OzonOrderModel
  | typeof selectColumnId
  | 'moySkladId'
  | 'logs'

export type OzonOrderColumn = TableColumn<OzonOrderColumnId, OzonOrderModel>

export const ozonOrderColumns: OzonOrderColumn[] =
  createColumns<OzonOrderColumnId, OzonOrderModel>({
    id: selectColumnId,
    title: 'Выбрать',
    CellComponent: TableSelectCell
  }, {
    id: 'id',
    title: 'Id'
  }, {
    id: 'createdAt',
    title: 'Дата создания',
    CellComponent: TableDateCell
  }, {
    id: 'ozonId',
    title: 'Id в Ozon'
  }, {
    id: 'postingNumber',
    title: 'Номер отправления'
  }, {
    id: 'products',
    title: 'Товары',
    accessor: _ => _.products.map(p => `${p.code} - ${p.name} (${p.quantity})`)
  }, {
    id: 'price',
    title: 'Цена продажи, ₽',
    accessor: _ => formatPrice(_.price),
    cellStyle: tableCellStyles.noWrap
  }, {
    id: 'commissionFee',
    title: 'Расходы, ₽',
    CellComponent: OzonOrderCommissionsCell
  }, {
    id: 'status',
    title: 'Статус'
  }, {
    id: 'moySkladId',
    title: 'GUID в МоёмСкладе',
    CellComponent: MoySkladIdCell
  }, {
    id: 'syncErrorId',
    title: 'Ошибки',
    CellComponent: OzonOrderSyncErrorCell
  }, {
    id: 'logs',
    title: 'Логи',
    CellComponent: OzonOrderSyncLogsCell
  })